import BaseSvg, { Props } from '../BaseSvg'

const Reply: React.FC<Props> = (props) => (
  <BaseSvg {...props}>
    <path d="M7 0l9 6.5L7 13V9.02C4.13 9.004 2.304 11.33 1.522 16-1.248 11.342-.338 3.092 7 3.034L7 0zm1.998 3.909v1.109l-1.983.016c-2.576.02-4.242 1.679-4.798 3.894l-.063.277.106-.12c1.168-1.3 2.667-2.012 4.5-2.062l.251-.003L9 7.032v2.057L12.584 6.5 8.998 3.909z" />
  </BaseSvg>
)

export default Reply
